import { Button } from '@eventbrite/marmalade';
import styles from './ViewDetailsButton.module.scss';
import { FormattedMessage } from 'react-intl';

interface ViewDetailsButtonProps {
  url?: string;
  onClick?: () => void;
}

export const ViewDetailsButton = ({ url, onClick }: ViewDetailsButtonProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (url) {
      window.location.href = url;
    }
  };

  return (
    <div className={styles.container}>
      <Button sizeVariant="large" className={styles.button} onClick={handleClick}>
        <FormattedMessage id="View all event details" />
      </Button>
    </div>
  );
};
